<div class="add-container">
    <h1 class="add-title text-center">
        Actualizare Semnatari 
        <span *ngIf="manual_override == false">Template Document</span>
        <span *ngIf="manual_override == true">Document Generat</span>
        <br /> <span>{{data.name}}</span>
    </h1>
    <button class="btn btn-light close-button" type="button" (click)="closeDialog()">
        {{ helper.dialogConfig.buttonLabels.close }}
    </button>

    <div *ngIf="data.document_generabil_dual == true">
        <mat-button-toggle-group name="fontStyle" aria-label="Font Style" (change)="onSwitchChange($event)"
            [value]="destinationToggle">
            <mat-button-toggle value="toPrimarie">Exemplar Semnatari</mat-button-toggle>
            <mat-button-toggle value="toCetatean">Exemplar Cetățean</mat-button-toggle>
        </mat-button-toggle-group>
    </div>
    <mat-expansion-panel class="add-card__form">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <!-- <mat-spinner diameter="32" class="mr-3" *ngIf="isLoading"></mat-spinner> -->
                <span class="w-100">Vă rugăm să selectați semnatarii doriți(funcții)</span>
                <button class="btn btn-primary" type="button" [disabled]="form.dirty"
                    (click)="updateSignaturesTemplateDocument($event)">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="add-field">
            <div *ngFor="let row of functiiOperator" class="checkbox">
                <mat-checkbox color="primary" [(ngModel)]="row.checked">
                    {{row.name}}
                </mat-checkbox>
            </div>
        </div>
    </mat-expansion-panel>

    <mat-expansion-panel class="add-card__form">
        <mat-expansion-panel-header>
            <mat-panel-title>
                <!-- <mat-spinner diameter="32" class="mr-3" *ngIf="isLoading"></mat-spinner> -->
                <span class="w-100">Vă rugăm să ordonați semnăturile de aplicat in cadrul unui document (drag &
                    drop)</span>
                <button class="btn btn-primary" type="button" [disabled]="form.dirty" (click)="saveOrder($event)">
                    {{ helper.dialogConfig.buttonLabels.save }}
                </button>
            </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="add-field">
            <div class="container-fluid" cdkDropList (cdkDropListDropped)="drop($event)">
                <div class="row align-items-center draggable-item" [ngClass]="{'dragging': isDragging}"
                    *ngFor="let row of functiiSelectedOrder; let i = index" cdkDrag (cdkDragStarted)="isDragging = true"
                    (cdkDragEnded)="isDragging = false;">
                    <div class="col-md-4 ">
                        {{row.functie}}
                    </div>
                    <div class="col-md-8">
                        <span class="order">{{row.order}}</span>
                        <mat-form-field class="signature w-auto" appearance="outline">
                            <mat-label>Tip semnătură</mat-label>
                            <mat-select [(ngModel)]="row.sign_type">
                                <mat-option *ngFor="let type of signatureTypes" [value]="type.value">
                                    {{ type.label }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>

    </mat-expansion-panel>
    <div class="section-spinner position-absolute" *ngIf="isLoading">
        <div class="spinner position-absolute top-50 start-50 translate-middle">
            <mat-spinner></mat-spinner>
            <h3 class="mt-2">{{ helper.dialogConfig.generalMessages.pleaseWait }}</h3>
        </div>
    </div>
</div>
<div *ngIf="data.isCerereDetalii" class="add-action-btns"
    style="margin: 20px; display: flex; justify-content: space-between;">
    <button class="buttons" type="button" mat-flat-button (click)="closeDialog()">
        {{ helper.dialogConfig.buttonLabels.close }}
    </button>
    <button class="buttons" type="submit" mat-flat-button color="primary" (click)="save()">
        {{ helper.dialogConfig.buttonLabels.save }}
    </button>
</div> 